package com.anjuros.website.redesign.sections.seo

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.redesign.components.RdExternalLink
import com.anjuros.website.redesign.components.RdEyebrow
import com.anjuros.website.redesign.components.RdPicture
import com.anjuros.website.redesign.components.RdSection
import com.anjuros.website.redesign.components.RdTag
import com.anjuros.website.redesign.styles.RdArrowStyle
import com.anjuros.website.redesign.styles.RdGhostButtonStyle
import com.anjuros.website.redesign.styles.RdH2Style
import com.anjuros.website.redesign.styles.RdSectionFlushTopStyle
import com.anjuros.website.redesign.styles.RdSectionStyle
import com.anjuros.website.redesign.styles.SeoCertDetailsStyle
import com.anjuros.website.redesign.styles.SeoCertGridStyle
import com.anjuros.website.redesign.styles.SeoCertImageStyle
import com.anjuros.website.redesign.styles.SeoStackStyle
import com.anjuros.website.redesign.util.RdExternal
import com.anjuros.website.redesign.util.RdImage
import com.anjuros.website.redesign.util.RdText
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

private val CertificateDetails = listOf(
    RdText.SEO_CERT_COURSE_LABEL to RdText.SEO_CERT_COURSE,
    RdText.SEO_CERT_LENGTH_LABEL to RdText.SEO_CERT_LENGTH,
    RdText.SEO_CERT_DATE_LABEL to RdText.SEO_CERT_DATE,
)

/** SEO training details with a link to verify the certificate. */
@Composable
fun SeoCertificateSection() {
    RdSection(
        id = "certified",
        labelledBy = "cert-h",
        modifier = RdSectionStyle.toModifier().then(RdSectionFlushTopStyle.toModifier()),
        wrapModifier = SeoCertGridStyle.toModifier(),
    ) {
        Div(SeoStackStyle.toModifier().toAttrs()) {
            RdEyebrow(RdText.SEO_CERT_EYEBROW)
            H2(RdH2Style.toModifier().id("cert-h").toAttrs()) { Text(LocalText(RdText.SEO_CERT_TITLE)) }
            P { Text(LocalText(RdText.SEO_CERT_TEXT)) }
            RdTag("dl", SeoCertDetailsStyle.toModifier()) {
                CertificateDetails.forEach { (label, value) ->
                    RdTag("dt") { Text(LocalText(label)) }
                    RdTag("dd") { Text(LocalText(value)) }
                }
            }
            RdExternalLink(RdExternal.SEO_CERTIFICATE, RdGhostButtonStyle.toModifier()) {
                Text(LocalText(RdText.SEO_CERT_VERIFY))
                Span(RdArrowStyle.toModifier().toAttrs()) { Text(" →") }
            }
        }
        RdExternalLink(RdExternal.SEO_CERTIFICATE, SeoCertImageStyle.toModifier()) {
            RdPicture(RdImage.SEO_CERTIFICATE, LocalText(RdText.SEO_CERT_ALT))
        }
    }
}
